import './InputDragAndDrop.scss'

import { useCallback } from 'react'
import { useDropzone } from 'react-dropzone'

const InputDragAndDrop = ({ setCoverImage, coverImage }) => {
  const onDrop = useCallback(
    (files) => {
      const droppedFile = files[0]

      try {
        setCoverImage(droppedFile)
      } catch (error) {
        console.error('Tipo de arquivo não suportado')
      }
    },
    [setCoverImage]
  )

  const dropzone = useDropzone({
    onDrop,
    accept: { 'image/*': [] }
  })

  return (
    <div
      {...dropzone.getRootProps()}
      className='drag-and-drop'
    >
      {coverImage ? (
        <img
          src={
            typeof coverImage === 'string'
              ? coverImage
              : URL.createObjectURL(coverImage)
          }
          alt='Prévia da imagem'
        />
      ) : (
        <p className='drag-and-drop-info-text'>
          {dropzone.isDragActive
            ? 'Arraste o seu arquivo até aqui'
            : 'Clique para selecionar ou arraste a capa do livro aqui'}
        </p>
      )}
      <input
        {...dropzone.getInputProps()}
        style={{ display: 'none' }}
      />
    </div>
  )
}

export default InputDragAndDrop
